import React, { useEffect, useState } from 'react';
import { Table, Row } from 'reactstrap';
import del from '../Res/Icon/delete.png';
import edit from '../Res/Icon/edit.png';
import ReleaseNote from './ReleaseNote';
import CustomModal from './CustomModal';
import WarningModal from './WarningModal';

const formatDate = dateToTransform => {
  const date = new Date(dateToTransform);

  return date.toLocaleString('en-US', { hour12: false });
};

const ActiveMaintenance = ({
  notes,
  updateReleaseNotes,
  closeMaintenanceModal,
  deleteReleaseNotes,
}) => {
  const [selectedNote, setSelectedNote] = useState({});
  const [isNoteSelected, setIsNoteSelected] = useState(false);
  const [changedNote, setChangedNote] = useState({});
  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [noteToDelete, setNoteToDelete] = useState({});

  const token = localStorage.getItem('jwtToken');

  const noteChanges = values => {
    setChangedNote(values);
  };

  const onEditHandle = note => {
    setSelectedNote(note);
    setIsNoteSelected(true);
  };

  const onChangeSubmit = async () => {
    await updateReleaseNotes(token, changedNote);
    setIsNoteSelected(false);
    closeMaintenanceModal(false);
  };

  const onDelete = async note => {
    setNoteToDelete(note);
    setIsDeleteConfirmOpen(true);
  };

  const onConfirm = async () => {
    const { _id: noteID } = noteToDelete;
    await deleteReleaseNotes(token, noteID);
    setIsDeleteConfirmOpen(false);
    closeMaintenanceModal(false);
  };

  const onCancel = () => {
    setIsDeleteConfirmOpen(false);
    closeMaintenanceModal(true);
  };

  return (
    <>
      <Table>
        <thead>
          <tr>
            <th>Title</th>
            <th>Frequency</th>
            <th>Login page</th>
            <th>Created On</th>
            <th>Starts On</th>
            <th>Expiration</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {notes.map(note => {
            return (
              <tr key={note._id}>
                <td>{note.title}</td>
                <td>{note.frequency}</td>
                <td>{note.displayOnLogin ? 'Yes' : 'No'}</td>
                <td>{formatDate(note.createdAt)}</td>
                <td>{formatDate(note.alertStartsOn).slice(0, -3)}</td>
                <td>{formatDate(note.alertExpiresOn).slice(0, -3)}</td>
                <td>
                  <img
                    onClick={() => {
                      onEditHandle(note);
                    }}
                    className="actions-icon"
                    src={edit}
                    alt="edit"
                  />
                  <img
                    onClick={() => {
                      onDelete(note);
                    }}
                    className="actions-icon"
                    src={del}
                    alt="delete"
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      <CustomModal
        isOpen={isNoteSelected}
        onCancel={() => setIsNoteSelected(false)}
        onConfirm={onChangeSubmit}
        wider
      >
        <ReleaseNote releaseFormValues={noteChanges} currentState={selectedNote} />
      </CustomModal>
      <WarningModal
        isOpen={isDeleteConfirmOpen}
        onCancel={() => onCancel()}
        onConfirm={() => onConfirm()}
        body={'Are you Sure you want to delete this maintenance notification?'}
        noButtonText="Cancel"
        yesButtonText="Yes"
      />
    </>
  );
};

export default ActiveMaintenance;
